import React from 'react';

const BasicInformationInput = ({ input, handleInputChange }) => (
  <div className="flex justify-between items-center mb-3">
    <div className="w-[50%]">
      <h4 className="text-[16px] font-bold font-poppin">
        {input.name}:
      </h4>
    </div>
    <input
      type={input.type}
      placeholder={input.placeholder}
      defaultValue={input.value}
      className="add_user_input w-full"
      onChange={handleInputChange}
      name={input.key}
    />
  </div>
);

export default BasicInformationInput;
